import PaymentPromoComponent from '../components/promocode';
import { FC } from 'react';
import { IPromocode, TOrder } from '../../../../lib/utils/types';

interface IPaymentMethodCardComponent {
  verifyPromocode: (value: string, type?: string) => void,
  setPromocodeApplied: (value?: IPromocode) => void,
  isShowPromocode: boolean,
  order: TOrder,
}

const PaymentMethodCardComponent: FC<IPaymentMethodCardComponent> = (props) => {
  const {
    isShowPromocode,
  } = props;

  return isShowPromocode && <PaymentPromoComponent applyButtonVisible {...props} /> || <></>
}

export default PaymentMethodCardComponent;